import React from 'react';
import { Link } from 'react-router-dom';
import { useAOS } from '../../hooks/useExternalLibs';
import { useLanguage } from '../../contexts/LanguageContext';

const ResearchDevelopment = () => {
  // Initialize external libraries using custom hooks
  useAOS();
  
  // Get translation function
  const { t } = useLanguage();

  return (
    <div className="service-details-page">
      {/* Page Title */}
      <div className="page-title dark-background" style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/assets/img/Photo-Building/eid1.JPG)` }}>
        <div className="container position-relative">
          <h1>{t('researchDevelopment.pageTitle')}</h1>
          <nav className="breadcrumbs">
            <ol>
              <li><Link to="/">{t('researchDevelopment.breadcrumbHome')}</Link></li>
              <li><Link to="/">{t('researchDevelopment.breadcrumbServices')}</Link></li>
              <li className="current">{t('researchDevelopment.breadcrumbCurrent')}</li>
            </ol>
          </nav>
        </div>
      </div>

      {/* Service Details Section */}
      <section id="service-details" className="service-details section">
        <div className="container">
          <div className="row gy-4">
            <div className="col-lg-4" data-aos="fade-up" data-aos-delay="100">
              <div className="services-list">
                <Link to="/services/custom-manufacturing">{t('researchDevelopment.customManufacturing')}</Link>
                <Link to="/services/technical-support">{t('researchDevelopment.technicalSupport')}</Link>
                <Link to="/services/after-sales-service">{t('researchDevelopment.afterSalesService')}</Link>
                <Link to="/services/quality-assurance">{t('researchDevelopment.qualityAssurance')}</Link>
                <Link to="/services/research-development" className="active">{t('researchDevelopment.researchDevelopment')}</Link>
                <Link to="/services/global-supply-chain">{t('researchDevelopment.globalSupplyChain')}</Link>
              </div>
            </div>
            <div className="col-lg-8" data-aos="fade-up" data-aos-delay="200">
              <div className="service-content text-center">
                <img src={`${process.env.PUBLIC_URL}/assets/img/building/building-ekk.png`} alt="Research & Development" className="img-fluid services-img mx-auto d-block" />
                <h3 className="text-center">{t('researchDevelopment.title')}</h3>
                <p className="text-center">
                  {t('researchDevelopment.description1')}
                </p>
                <p className="text-center">
                  {t('researchDevelopment.description2')}
                </p>
                <h4 className="text-center">{t('researchDevelopment.focusTitle')}</h4>
                <ul className="text-start">
                  {t('researchDevelopment.focusAreas').map((area, index) => (
                    <li key={index}><i className="bi bi-check-circle"></i> <span>{area}</span></li>
                  ))}
                </ul>
                
                <h4 className="text-center">{t('researchDevelopment.facilitiesTitle')}</h4>
                <p className="text-center">
                  {t('researchDevelopment.facilitiesDescription')}
                </p>
                
                <div className="row gy-4 mt-4">
                  <div className="col-lg-6">
                    <div className="service-metric text-center">
                      <h5>{t('researchDevelopment.innovationPipeline')}</h5>
                      <p>{t('researchDevelopment.innovationPipelineDesc')}</p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="service-metric text-center">
                      <h5>{t('researchDevelopment.technicalExpertise')}</h5>
                      <p>{t('researchDevelopment.technicalExpertiseDesc')}</p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="service-metric text-center">
                      <h5>{t('researchDevelopment.collaborationNetwork')}</h5>
                      <p>{t('researchDevelopment.collaborationNetworkDesc')}</p>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="service-metric text-center">
                      <h5>{t('researchDevelopment.technologyTransfer')}</h5>
                      <p>{t('researchDevelopment.technologyTransferDesc')}</p>
                    </div>
                  </div>
                </div>
                
                <h4 className="text-center">{t('researchDevelopment.processTitle')}</h4>
                <p className="text-center">
                  {t('researchDevelopment.processDescription')}
                </p>
                
                <h4 className="text-center">{t('researchDevelopment.ipTitle')}</h4>
                <p className="text-center">
                  {t('researchDevelopment.ipDescription')}
                </p>
                
                <h4 className="text-center">{t('researchDevelopment.futureTitle')}</h4>
                <p className="text-center">
                  {t('researchDevelopment.futureDescription')}
                </p>
                
                <div className="text-center">
                  <Link to="/contact" className="btn btn-primary">{t('researchDevelopment.discussRAndD')}</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Related Services Section */}
      <section id="related-services" className="related-services section">
        <div className="container">
          <div className="section-title" data-aos="fade-up">
            <h2>{t('researchDevelopment.relatedServicesTitle')}</h2>
            <p>{t('researchDevelopment.relatedServicesDescription')}</p>
          </div>
          <div className="row gy-4">
            <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="100">
              <div className="service-item position-relative">
                <div className="icon">
                  <i className="fa-solid fa-mountain-city"></i>
                </div>
                <h3>{t('researchDevelopment.customManufacturing')}</h3>
                <p>{t('researchDevelopment.customManufacturingDesc')}</p>
                <Link to="/services/custom-manufacturing" className="readmore stretched-link">{t('researchDevelopment.readMore')} <i className="bi bi-arrow-right"></i></Link>
              </div>
            </div>
            <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="200">
              <div className="service-item position-relative">
                <div className="icon">
                  <i className="fa-solid fa-trowel-bricks"></i>
                </div>
                <h3>{t('researchDevelopment.qualityAssurance')}</h3>
                <p>{t('researchDevelopment.qualityAssuranceDesc')}</p>
                <Link to="/services/quality-assurance" className="readmore stretched-link">{t('researchDevelopment.readMore')} <i className="bi bi-arrow-right"></i></Link>
              </div>
            </div>
            <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="300">
              <div className="service-item position-relative">
                <div className="icon">
                  <i className="fa-solid fa-arrow-up-from-ground-water"></i>
                </div>
                <h3>{t('researchDevelopment.technicalSupport')}</h3>
                <p>{t('researchDevelopment.technicalSupportDesc')}</p>
                <Link to="/services/technical-support" className="readmore stretched-link">{t('researchDevelopment.readMore')} <i className="bi bi-arrow-right"></i></Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ResearchDevelopment;